import { userRepository } from '@webapp/platform/iam/data-access/repositories/UserRepository'
import { GetOrderRequestFlowPreferenceUseCase } from './GetOrderRequestFlowPreferenceUseCase'

export const getOrderRequestFlowPreferenceUseCase =
  new GetOrderRequestFlowPreferenceUseCase({
    userRepository,
  }).execute
